import {
  SET_LATEST_PAYROLLS_LIST,
  SET_DATES_WITH_PAYROLLS
} from '../constants/actionTypes/payroll';

export const initialState = {
  latestPayrollList: null,
  datesWithPayrolls: null
};

export default (state = initialState, action) => {
  const { type, latestPayrollList, datesWithPayrolls } = action;

  switch (type) {
    case SET_LATEST_PAYROLLS_LIST:
      return {
        ...state,
        latestPayrollList
      };

    case SET_DATES_WITH_PAYROLLS:
      return {
        ...state,
        datesWithPayrolls
      };

    default:
      return state;
  }
};
